import api from "../../api/api";
import API_URL from "../../api/url";


const CategoryRequest = {
  categoryList: (values) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}`, {
    params: {
      search: values?.search,
      page: values?.page,
      limit: values?.limit,
      gender: values?.gender,
    }
  }),
  deleteCategory: (id) => api.post(`${API_URL.BASEURL}${API_URL.deleteCategory}?id=${id}`,),
  updateCategory: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateCategory}`, values),
  categoryDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.categoryDetail}?id=${id}`),
  createCategory: (values) => api.post(`${API_URL.BASEURL}${API_URL.createCategory}`, values),
  getServiceByCategory: (id) => api.get(`${API_URL.BASEURL}${API_URL.getServiceByCategory}?categoryId=${id}`),
  updateService: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateServices}`, values),
  createService: (values) => api.post(`${API_URL.BASEURL}${API_URL.createServices}`, values),
  serviceDetails: (id) => api.get(`${API_URL.BASEURL}${API_URL.serviceDetail}?id=${id}`),
  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");
    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=categories`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  },

  uploadServiceImage: (formData) => {
    const token = localStorage.getItem("accesstoken");
    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=services`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }
}
export default CategoryRequest
